<template>
  <header id="header" class="site-header">
    <div class="container">
      <div class="header-inner">
        <router-link class="brand" to="/">
          <span class="brand-mark"></span>
          <span class="brand-copy">
            <strong class="brand-name">重庆安宸佑科技</strong>
            <small class="brand-sub">会员权益解决方案</small>
          </span>
        </router-link>

        <nav class="desktop-nav">
          <router-link
            v-for="item in navList"
            :key="item.path"
            :to="item.path"
            class="nav-link"
            :class="{ active: $route.path === item.path }"
          >
            <span class="nav-name">{{ item.name }}</span>
          </router-link>
        </nav>

        <div class="header-actions">
          <button class="mobile-toggle" type="button" @click="menuOpen = !menuOpen" aria-label="切换导航">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      <transition name="fade">
        <div v-if="menuOpen" class="mobile-panel">
          <div class="mobile-panel-inner">
            <router-link
              v-for="item in navList"
              :key="item.path"
              :to="item.path"
              class="mobile-link"
              :class="{ active: $route.path === item.path }"
              @click.native="menuOpen = false"
            >
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      menuOpen: false,
      navList: [
        { name: "首页", path: "/" },
        { name: "产品中心", path: "/software" },
        { name: "相关服务", path: "/service" },
        { name: "案例中心", path: "/casecenter" },
        { name: "咨询中心", path: "/newsinformation" },
        { name: "关于我们", path: "/companyintroduction" },
        { name: "联系我们", path: "/contactus" }
      ]
    };
  },
  watch: {
    $route() {
      this.menuOpen = false;
    }
  }
};
</script>

<style scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 999;
  padding: 0;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(16, 32, 46, 0.08);
  box-shadow: none;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  min-height: 76px;
  padding: 0 4px;
  border-radius: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  flex: 0 0 auto;
}

.brand-mark {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(236, 243, 251, 0.96)),
    var(--surface-strong);
  border: 1px solid rgba(22, 36, 52, 0.08);
  box-shadow: 0 10px 20px rgba(22, 36, 52, 0.08);
  overflow: hidden;
}

.brand-mark::before,
.brand-mark::after {
  content: "";
  position: absolute;
  display: block;
}

.brand-mark::after {
  right: 7px;
  top: 7px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent-2);
  box-shadow: 0 0 0 4px rgba(27, 154, 179, 0.14);
}

.brand-mark::before {
  inset: 7px 10px 7px 9px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--accent) 0%, #5b86f5 55%, var(--accent-2) 100%);
  transform: skewX(-18deg);
  transform-origin: center;
}

.brand-copy {
  display: flex;
  flex-direction: column;
}

.brand-name {
  font-size: 18px;
  line-height: 1.1;
  font-weight: 800;
}

.brand-sub {
  margin-top: 4px;
  color: var(--muted);
  font-size: 12px;
}

.desktop-nav {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  min-height: 76px;
  padding: 0 14px;
  border-radius: 0;
  color: rgba(16, 32, 46, 0.76);
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}

.nav-link:hover {
  color: var(--text);
  background: rgba(16, 32, 46, 0.03);
}

.nav-link.active {
  color: var(--accent);
  background: rgba(47, 107, 219, 0.08);
  border-bottom-color: var(--accent);
}

.nav-name {
  line-height: 1.2;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.mobile-toggle {
  display: none;
  width: 42px;
  height: 42px;
  padding: 0;
  border: 1px solid rgba(16, 32, 46, 0.1);
  border-radius: 12px;
  background: #fff;
  box-shadow: none;
}

.mobile-toggle span {
  display: block;
  width: 18px;
  height: 2px;
  margin: 3px auto;
  border-radius: 999px;
  background: var(--text);
}

.mobile-panel {
  margin-top: 0;
  padding-bottom: 12px;
}

.mobile-panel-inner {
  padding: 14px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(16, 32, 46, 0.08);
  box-shadow: 0 12px 24px rgba(16, 32, 46, 0.06);
}

.mobile-link {
  display: block;
  padding: 14px 4px;
  border-bottom: 1px solid rgba(16, 32, 46, 0.08);
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
}

.mobile-link:last-child {
  border-bottom: 0;
}

.mobile-link.active {
  color: var(--accent);
}

@media screen and (max-width: 991px) {
  .site-header {
    top: 0;
    padding: 0;
  }

  .desktop-nav {
    display: none;
  }

  .mobile-toggle {
    display: inline-grid;
    place-items: center;
  }
}

@media screen and (max-width: 767px) {
  .header-inner {
    min-height: 68px;
    padding: 0 2px;
  }

  .brand-name {
    font-size: 16px;
  }

  .brand-sub {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue